<template>
  <v-app>

  </v-app>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { getUserData, getGeneData, editUserData, getFileDownloadURL, getMessage} from '../helper/firestore'
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  components: {

  },
  methods: {

  },
  computed: {

  },
}
</script>
<style scoped>

</style>
